import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Modal,
  Button,
  Divider,
  Checkbox,
  TextField,
  InputAdornment,
  CircularProgress,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CallScreenBackground from "../../../../assets/images/CallScreenBackground.png";
import chatIcon from "../../../../assets/icons/ChatIcon.svg";
import shareScreen from "../../../../assets/icons/shareScreen.svg";
import AddPeople from "../../../../assets/icons/AddPeople.svg";
import record from "../../../../assets/icons/record.svg";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import VideocamOffRoundedIcon from "@mui/icons-material/VideocamOffRounded";
import CallEndRoundedIcon from "@mui/icons-material/CallEndRounded";
import MicOffRoundedIcon from "@mui/icons-material/MicOffRounded";
import MicRoundedIcon from "@mui/icons-material/MicRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { useDispatch, useSelector } from "react-redux";
import {
  setCallRunningInBG,
  setAudioCallStart,
  setShowChatSectionDuringCall,
  setUserById,
  setIsReceiveMuted,
  setIsReceiveRecording,
  setIsMuted,
  setContactImage,
  setDialingNumber,
  setMissedCallCount,
  setMissedCallParticipantId,
  setUserBusyModel,
} from "../../../services/store/slice/CallSlice";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import {
  addParticipantPostAPI,
  startRecordingAPI,
  stopRecordingAPI,
  getUserContactsByParams,
  getUsersById,
  getVideoCallToken,
  addCallRecords,
  getMissedCallCount,
  addParticipantByFormData,
  MoveAddParticipantPostAPI,
  MoveToConferencePostAPI,
  ringCentralCallStatus,
  ringCentralSessionRecording,
  ringCentralRecordingContentUrl,
} from "../../../services/api/apiManager";
import SearchIcon from "@mui/icons-material/Search";
import { settings as s } from "../../../services/Settings";
import { connect, LocalVideoTrack } from "twilio-video";
import dayjs from "dayjs";
import { BgCallPopupContext } from "../../../services/context/BgCallPopupContext";
import MenuIcon from "@mui/icons-material/Menu";
import { useSnackbar } from "notistack";
import {
  newCallLogs,
  SendAddParticipant,
  SendMute,
  SendRecording,
  SendShareScreen,
  SetCallSid,
} from "../../../services/signalRService/signalRService";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import KeyboardHideIcon from "@mui/icons-material/KeyboardHide";
import { useTwilio } from "../../../services/context/TwilioContext";
import { useRingCentralWebPhone } from "../../../services/ringcentral/useRingCentralWebPhone";
import { useTheme } from "@emotion/react";
import ringCentralWebPhoneService from "../../../services/ringcentral/ringCentralWebPhoneService";
function CallScreen() {
  const {
    userOffline,
    callDuration,
    setCallDuration,
    callAccepted,
    setCallAccepted,
    activeConnection,
    setActiveConnection,
    callStatus,
    setCallStatus,
    callStartTime,
    chat_Id,
    setCallLogsCallId,
    callLogsCallId,
    setCallEnded,
    callEnded,
    handleDialConferenceCall,
  } = useTwilio();
  const {
    sendDtmf: sendRingCentralDtmf,
    hangup: hangupRingCentral,
    mute: muteRingCentral,
    hold: holdRingCentral,
  } = useRingCentralWebPhone();
  // function ke andar
  const navigate = useNavigate();
  const { setIsCallActive } = BgCallPopupContext();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const {
    showChatSectionDuringCall,
    userById,
    callerName,
    contactImage,
    isReceiveMuted,
    isReceiveRecording,
    isShareScreen,
    isMuted,
    dialingNumber,
    sendCallChatId,
    callSid,
    toCallingPersonName,
  } = useSelector((state) => state.call);
  const user_id = localStorage.getItem("user_id");
  const username = localStorage.getItem("username");
  const picPath = localStorage.getItem("picPath");
  const [isCamera, setIsCamera] = React.useState(false);
  const [calllRecording, setCallRecording] = useState(null);
  const [nameMuted, setNameMuted] = useState([]);
  const [isOnHold, setIsOnHold] = useState(false);
  const getSelectedCallProvider = () =>
    localStorage.getItem("selectedCallProvider") || "RingCentral";
  const isRingCentralCall = getSelectedCallProvider() === "RingCentral";
  // Screen Sharing States
  const generateRoomName = (senderId, receiverId) => {
    if (!senderId || !receiverId) {
      return;
    }
    const sortedIds = [senderId, receiverId].sort().join("-");
    return `ScreenSharingRoom-${sortedIds}`;
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isSharing, setIsSharing] = useState(false);
  const [isReconnecting, setIsReconnecting] = useState(false);
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [room, setRoom] = useState(null);
  const localMediaRef = useRef(null);
  const remoteMediaRef = useRef(null);
  const localScreenTrackRef = useRef(null);
  const localParticipant = useRef(null);
  // Dial Pad for External Call
  const [dialOpen, setDialOpen] = React.useState(false);
  const [errValidMsg, setErrValidMsg] = React.useState("");
  const clickTimeout = useRef(null);
  const inputRef = useRef(null);
  const [display, setDisplay] = useState("");
  const handleDialModalClose = () => setDialOpen(false);
  const handleDialModalOpen = () => setDialOpen(true);

  const handleBackspace = () => {
    if (!inputRef.current) return;
    setErrValidMsg("");
    const cursorPosition = inputRef.current.selectionStart;

    if (cursorPosition > 0) {
      const newValue =
        display.slice(0, cursorPosition - 1) + display.slice(cursorPosition);
      setDisplay(newValue);

      setTimeout(() => {
        inputRef.current.selectionStart = cursorPosition - 1;
        inputRef.current.selectionEnd = cursorPosition - 1;
      }, 0);
    }
  };

  const numbersArray = [
    { number: "1", letters: "" },
    { number: "2", letters: "A B C" },
    { number: "3", letters: "D E F" },
    { number: "4", letters: "G H I" },
    { number: "5", letters: "J K L" },
    { number: "6", letters: "M N O" },
    { number: "7", letters: "P Q R S" },
    { number: "8", letters: "T U V" },
    { number: "9", letters: "W X Y Z" },
    { number: "*", letters: "" },
    { number: "0", letters: "+" },
    { number: "#", letters: "" },
  ];

  // region Handle Number Click (for DTMF and Input)

  // const handleNumberClick = async (number) => {
  //   try {
  //     if (!number) return;

  //     const provider = getSelectedCallProvider();

  //     // ======================
  //     // RINGCENTRAL FIXED FLOW
  //     // ======================
  //     if (getSelectedCallProvider() === "RingCentral") {
  //       // ✅ صرف connected state میں بھیجیں
  //       const session = ringCentralWebPhoneService.getCurrentSession();
  //       if (!session) {
  //         console.warn("No active session for DTMF");
  //         return;
  //       }
  //       sendRingCentralDtmf(number);
  //     } else if (activeConnection) {
  //       activeConnection.sendDigits(number);
  //     }

  //     // ======================
  //     // TWILIO FLOW
  //     // ======================
  //     else if (activeConnection) {
  //       activeConnection.sendDigits(number);
  //     }
  //   } catch (error) {
  //     console.error("Failed to send DTMF", error);
  //   }

  //   // ======================
  //   // UI INPUT LOGIC (UNCHANGED)
  //   // ======================
  //   if (!inputRef.current) return;

  //   const cursorPosition = inputRef.current.selectionStart;

  //   if (number === "0") {
  //     if (clickTimeout.current) {
  //       clearTimeout(clickTimeout.current);
  //       clickTimeout.current = null;

  //       const newDisplay =
  //         display.slice(0, cursorPosition) +
  //         "+" +
  //         display.slice(cursorPosition);

  //       setDisplay(newDisplay);

  //       setTimeout(() => {
  //         inputRef.current.selectionStart = cursorPosition + 1;
  //         inputRef.current.selectionEnd = cursorPosition + 1;
  //       }, 0);
  //     } else {
  //       clickTimeout.current = setTimeout(() => {
  //         const newDisplay =
  //           display.slice(0, cursorPosition) +
  //           "0" +
  //           display.slice(cursorPosition);

  //         setDisplay(newDisplay);

  //         setTimeout(() => {
  //           inputRef.current.selectionStart = cursorPosition + 1;
  //           inputRef.current.selectionEnd = cursorPosition + 1;
  //         }, 0);

  //         clickTimeout.current = null;
  //       }, 200);
  //     }
  //   } else {
  //     const newDisplay =
  //       display.slice(0, cursorPosition) +
  //       number +
  //       display.slice(cursorPosition);

  //     setDisplay(newDisplay);

  //     setTimeout(() => {
  //       inputRef.current.selectionStart = cursorPosition + 1;
  //       inputRef.current.selectionEnd = cursorPosition + 1;
  //     }, 0);
  //   }
  // };

  const handleNumberClick = async (number) => {
    try {
      if (!number) return;

      if (getSelectedCallProvider() === "RingCentral") {
        const session = ringCentralWebPhoneService.getCurrentSession();
        if (!session) {
          console.warn("No active RingCentral session for DTMF");
          return;
        }
        sendRingCentralDtmf(number);
      } else if (activeConnection) {
        activeConnection.sendDigits(number);
      }
    } catch (error) {
      console.error("Failed to send DTMF", error);
    }

    // UI Input Logic
    if (!inputRef.current) return;

    const cursorPosition = inputRef.current.selectionStart;

    if (number === "0") {
      if (clickTimeout.current) {
        clearTimeout(clickTimeout.current);
        clickTimeout.current = null;

        const newDisplay =
          display.slice(0, cursorPosition) +
          "+" +
          display.slice(cursorPosition);

        setDisplay(newDisplay);

        setTimeout(() => {
          inputRef.current.selectionStart = cursorPosition + 1;
          inputRef.current.selectionEnd = cursorPosition + 1;
        }, 0);
      } else {
        clickTimeout.current = setTimeout(() => {
          const newDisplay =
            display.slice(0, cursorPosition) +
            "0" +
            display.slice(cursorPosition);

          setDisplay(newDisplay);

          setTimeout(() => {
            inputRef.current.selectionStart = cursorPosition + 1;
            inputRef.current.selectionEnd = cursorPosition + 1;
          }, 0);

          clickTimeout.current = null;
        }, 200);
      }
    } else {
      const newDisplay =
        display.slice(0, cursorPosition) +
        number +
        display.slice(cursorPosition);

      setDisplay(newDisplay);

      setTimeout(() => {
        inputRef.current.selectionStart = cursorPosition + 1;
        inputRef.current.selectionEnd = cursorPosition + 1;
      }, 0);
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value) {
      setErrValidMsg("");
    }
    const inputValue = event.target.value;
    const filteredValue = inputValue?.replace(/[^0-9*#+]/g, "");
    if (filteredValue) {
      setDisplay(filteredValue);
    }
  };

  const handleCloseDialPad = () => {
    setDisplay("");
    setErrValidMsg("");
    handleDialModalClose();
  };
  // Get User By Id data

  const fetchToken = async (activeConnection) => {
    try {
      const userId =
        activeConnection?.parameters?.From?.split(":")[1] ||
        activeConnection?.message?.To;
      // This only applies to Twilio connections (which carry a numeric app user
      // id here). RingCentral/WebRTC connections have no such field, so `userId`
      // is undefined; a "+..." value is a phone number. In both cases there's no
      // app user to look up — dispatch null and DON'T call GetUserById, which
      // 400s on `UserId=undefined`.
      if (!userId || (typeof userId === "string" && userId.startsWith("+"))) {
        dispatch(setUserById(null));
        return;
      }
      const response = await getUsersById(userId);
      dispatch(setUserById(response?.data?.result?.[0]));
    } catch (error) {
      console.error(`Error:`, error);
    }
  };
  useEffect(() => {
    if (activeConnection) {
      fetchToken(activeConnection);
    }
  }, [activeConnection]);

  // region Add Participant
  const [showParticipantUI, setShowParticipantUI] = React.useState(false);
  const [conferenceRoomName, setConferenceRoomName] = React.useState("");
  const [activeConferenceRoom, setActiveConferenceRoom] = React.useState("");
  const [pendingRequests, setPendingRequests] = useState([]);
  const [participants, setParticipants] = useState([]);

  // Responsive size adjustment
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const boxSize = isSmallScreen ? 100 : 150;

  // For UI layout Participant Calls

  const generateColorFromString = (string) => {
    let hash = 0;
    for (let i = 0; i < string?.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 340}, 50%, 70%)`;
    return color;
  };

  const renderVideoLayout = () => {
    const numParticipants = participants?.length + pendingRequests?.length;
    let columns;
    if (numParticipants === 1) {
      columns = 1;
    } else if (numParticipants <= 4) {
      columns = 2;
    } else if (numParticipants <= 9) {
      columns = 3;
    } else {
      columns = 4;
    }

    return {
      display: "grid",
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: "10px",
      padding: 2,
      width: "80%",
      justifyContent: "center",
      alignItems: "center",
    };
  };

  // Participant Modal
  const [addparticipantModal, setAddparticipantModal] = React.useState(false);
  const handleAddParticipantOpen = () => setAddparticipantModal(true);
  const handleAddParticipantClose = () => setAddparticipantModal(false);
  const [userContactList, setUserContactList] = React.useState([]);
  const [searchParticipant, setSearchParticipant] = React.useState("");
  const [checkedIds, setCheckedIds] = React.useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const Rows = 20;
  const [hasMore, setHasMore] = useState(true);
  const handleCheckboxChange = (user) => {
    setCheckedIds((prev) => {
      const exists = prev.some((u) => u.userid === user.userid);
      if (exists) {
        return prev.filter((u) => u.userid !== user.userid);
      } else {
        return [...prev, user];
      }
    });
  };

  const fetchContacts = useCallback(
    async (isSearch = false) => {
      if (!isSearch && !hasMore) return;

      setIsFetching(true);
      try {
        const response = await getUserContactsByParams(
          user_id,
          Rows,
          pageNumber,
          false,
          false,
          searchParticipant,
        );
        const newContacts = response?.data?.result || [];

        setUserContactList((prev) =>
          isSearch ? newContacts : [...prev, ...newContacts],
        );
        setHasMore(newContacts?.length == Rows);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      } finally {
        setIsFetching(false);
      }
    },
    [user_id, Rows, pageNumber, searchParticipant, hasMore],
  );
  useEffect(() => {
    if (searchParticipant !== "") {
      setPageNumber(1);
      fetchContacts(true);
    } else {
      fetchContacts();
    }
  }, [searchParticipant, fetchContacts]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50 && !isFetching) {
      setPageNumber((prev) => prev + 1);
    }
  };

  // const dataMoveToConference = {
  //   callSid: activeConnection?.mediaStream?.callSid,
  //   callSid1: callSid,
  // };
  // const dataMoveToAddParticipant = { To: "70045", From: user_id };
  // const resp = await MoveToConferencePostAPI(dataMoveToConference);
  // if (resp?.status === 200) {
  //   console.log(`check response callSid-->`, resp);
  //   const resp1 = await MoveAddParticipantPostAPI(dataMoveToAddParticipant);
  //   console.log(`check response-->1`, resp1);
  //   SendCallAccept("AddParticipant");
  // }

  const addParticipantMember = async (checkedIds) => {
    try {
      const conferenceRoomName1 = `conf-${user_id}-${Date.now()}`;
      setConferenceRoomName(conferenceRoomName1);
      setShowParticipantUI(true);
      SendAddParticipant(
        conferenceRoomName1,
        user_id,
        checkedIds?.map((user) => String(user?.userid)),
      );
      // setPendingRequests((prev) => [
      //   ...prev,
      //   ...checkedIds?.map((user) => ({ ...user, joined: false })),
      // ]);
      setPendingRequests([
        ...pendingRequests,
        ...checkedIds.map((user) => ({
          ...user,
          joined: false,
          connecting: true,
        })),
      ]);

      setParticipants(() => [
        {
          id: user_id,
          name: username,
          avatar: userById?.profilePicPath != picPath ? picPath : null,
          joined: true,
        },
        {
          id: userById ? userById?.userId : null,
          name: userById
            ? `${userById.firstName} ${userById.lastName}`
            : callerName,
          avatar: userById?.profilePicPath ? userById?.profilePicPath : null,
          joined: true,
        },
      ]);

      // checkedIds.forEach((user) => {
      //   setTimeout(() => {
      //     // Simulate participant accepting after 2-5 seconds
      //     const joinTime = 2000 + Math.random() * 3000;

      //     setTimeout(() => {
      //       setPendingRequests((prev) =>
      //         prev.filter((p) => p.userid !== user.userid)
      //       );

      //       setParticipants((prev) => [
      //         ...prev,
      //         {
      //           id: user.userid,
      //           name: `${user.firstName} ${user.lastName}`,
      //           avatar: user.profilePic,
      //           joined: true,
      //         },
      //       ]);

      //       // Simulate the participant joining the Twilio room
      //       StartConfCall(conferenceRoomName, user.userid);
      //     }, joinTime);
      //   }, 0);
      // });

      setTimeout(() => {
        // Disconnect original call
        // if (activeConnection) {
        //   activeConnection.disconnect();
        //   setActiveConnection(null);
        // }

        // Join the conference room
        joinConferenceRoom(conferenceRoomName);
      }, 1000);

      handleAddParticipantClose();

      // setTimeout(() => {
      //   setParticipants([]);
      //   setPendingRequests([]);
      //   setShowParticipantUI(false);
      // }, 35000);
      // Simulate user joining after 3 seconds
      // setTimeout(() => {
      //   // setParticipants([...participants, { ...checkedIds, joined: true }]);
      //   setParticipants((prev) => [
      //     ...prev,
      //     ...checkedIds.map((user) => ({ ...user, joined: true })),
      //   ]);
      //   // setPendingRequests(
      //   //   pendingRequests.filter((user) => user.id != checkedIds)
      //   // );
      //   setPendingRequests((prev) =>
      //     prev.filter(
      //       (user) =>
      //         !checkedIds.some(
      //           (checkedUser) => checkedUser.userid === user.userid
      //         )
      //     )
      //   );
      // }, 3000);
      // }
    } catch (error) {
      console.error("Error adding participant:", error);
    }
  };

  // const joinConferenceRoom = async (roomName) => {
  //   try {
  //     const response = await getVideoCallToken(user_id, roomName);
  //     const token = response?.data?.token;
  //     // Connect to the room
  //     const room = await connect(token, {
  //       name: roomName,
  //       audio: true,
  //       video: false,
  //     });

  //     setActiveConferenceRoom(room);

  //     // Handle participants
  //     room.on("participantConnected", (participant) => {
  //       setParticipants((prev) => [
  //         ...prev,
  //         {
  //           id: participant.identity,
  //           name: participant.identity,
  //           avatar: null,
  //           joined: true,
  //         },
  //       ]);
  //     });

  //     room.on("participantDisconnected", (participant) => {
  //       setParticipants((prev) =>
  //         prev.filter((p) => p.id != participant.identity)
  //       );
  //     });
  //   } catch (error) {
  //     console.error("Error joining conference:", error);
  //   }
  // };

  const joinConferenceRoom = async (roomName) => {
    try {
      const response = await getVideoCallToken(user_id, roomName);
      const token = response?.data?.token;
      const connectedRoom = await connect(token, {
        name: roomName,
        audio: true,
        video: false,
      });

      setActiveConferenceRoom(connectedRoom);

      // Handle existing participants
      connectedRoom.participants.forEach((participant) => {
        addRemoteParticipantTracks(participant);
      });

      // Handle new participants connecting
      connectedRoom.on("participantConnected", (participant) => {
        addRemoteParticipantTracks(participant);

        // Update UI state when someone joins
        setPendingRequests((prev) =>
          prev.filter((p) => p.userid != participant.identity),
        );

        setParticipants((prev) => [
          ...prev,
          {
            id: participant.identity,
            name: participant.identity,
            avatar: null,
            joined: true,
          },
        ]);
      });

      connectedRoom.on("participantDisconnected", (participant) => {
        setParticipants((prev) =>
          prev.filter((p) => p.id !== participant.identity),
        );
      });
    } catch (error) {
      console.error("Error joining conference:", error);
    }
  };
  const endConferenceCall = () => {
    if (activeConferenceRoom) {
      activeConferenceRoom.disconnect();
      setActiveConferenceRoom(null);
    }

    setParticipants([]);
    setPendingRequests([]);
    setShowParticipantUI(false);
    setConferenceRoomName(null);
  };

  // region Call Audio Recording
  const [isRecording, setIsRecording] = React.useState(false);
  const [recordingSid, setRecordingSid] = React.useState("");
  // RingCentral recording: remembers the session the user flagged for download
  // and guards against firing the call-end download more than once.
  const rcRecordingRef = React.useRef(null);
  const rcDownloadFiredRef = React.useRef(false);

  // RingCentral records EVERY call automatically (account-level Automatic Call
  // Recording). On-demand recording can't be layered on top of that, so the
  // button doesn't start a separate recording — it just shows the indicator and
  // flags that the user wants this call's automatic recording. The recording is
  // finalized only AFTER the call ends, so the actual download happens on call
  // end (see downloadRingCentralRecording, called from onEndCall).
  const onToggleRingCentralRecording = async () => {
    if (!isRecording) {
      // Pass appUserId so the backend queries the user's POOLED extension's
      // active-calls (extension-scoped) — otherwise the session isn't found.
      const statusRes = await ringCentralCallStatus("", user_id);
      const telephonySessionId = statusRes?.data?.telephonySessionId;
      if (!telephonySessionId) {
        enqueueSnackbar("Could not mark recording: call session not found.", {
          variant: "error",
        });
        return;
      }
      rcRecordingRef.current = { telephonySessionId, requested: true };
      rcDownloadFiredRef.current = false;
      setIsRecording(true);
      SendRecording(null, parseInt(user_id), null, true);
      enqueueSnackbar("Recording will download when the call ends.", {
        variant: "info",
      });
    } else {
      // Turn off the indicator, but keep the download intent — the recording is
      // only available once the call ends.
      setIsRecording(false);
      SendRecording(null, parseInt(user_id), null, false);
    }
  };

  // After the call ends, poll the call log for this session's automatic recording
  // id (it takes a few seconds to finalize), then download it via the proxy.
  const downloadRingCentralRecording = async (telephonySessionId) => {
    if (!telephonySessionId) return;
    for (let attempt = 0; attempt < 8; attempt++) {
      await new Promise((r) => setTimeout(r, attempt === 0 ? 3000 : 3000));
      try {
        const res = await ringCentralSessionRecording(telephonySessionId);
        const recordingId = res?.data?.recordingId;
        if (recordingId) {
          // Call handleDownload directly (not via setCallRecording state): the
          // call has ended and this screen may already be unmounting, so a
          // state-driven useEffect would not fire.
          await handleDownload(ringCentralRecordingContentUrl(recordingId));
          return;
        }
      } catch (e) {
        /* keep polling */
      }
    }
    enqueueSnackbar(
      "Recording is still processing. You can download it later from call history.",
      { variant: "warning" },
    );
  };

  // Fire the recording download exactly once when the call ends, if the user
  // pressed Record during the call. Safe to call from multiple end paths.
  const maybeDownloadRcRecording = () => {
    const info = rcRecordingRef.current;
    if (info?.requested && !rcDownloadFiredRef.current) {
      rcDownloadFiredRef.current = true;
      const sessionId = info.telephonySessionId;
      rcRecordingRef.current = null;
      downloadRingCentralRecording(sessionId);
    }
  };

  const onToggleRecording = async () => {
    if (isRingCentralCall) {
      return onToggleRingCentralRecording();
    }
    const data = {
      callSid: activeConnection?.parameters?.CallSid,
    };
    if (isRecording) {
      const dataOfStopRecording = {
        callSid: activeConnection?.parameters?.CallSid,
        recordingSid: recordingSid,
      };
      setIsRecording(false);
      SendRecording(
        activeConnection?.message?.To === undefined
          ? parseInt(
              activeConnection?.parameters?.From?.replace("client:", ""),
              10,
            )
          : activeConnection?.message?.To,
        parseInt(user_id),
        data?.callSid,
        false,
      );
      const res = await stopRecordingAPI(dataOfStopRecording);
      if (res?.status === 200) {
        setTimeout(() => {
          setCallRecording(res.data.recordingUrl);
        }, 2000);
      }
    } else {
      setIsRecording(true);
      SendRecording(
        activeConnection?.message?.To === undefined
          ? parseInt(
              activeConnection?.parameters?.From?.replace("client:", ""),
              10,
            )
          : activeConnection?.message?.To,
        parseInt(user_id),
        data?.callSid,
        true,
      );
      const response = await startRecordingAPI(data);
      setRecordingSid(response?.data?.recordingSid);
    }
  };
  // recording call download function
  const handleDownload = async (callRecordingURL) => {
    // The recording can take a few seconds to become available after stop, so
    // retry a few times before giving up.
    for (let attempt = 0; attempt < 5; attempt++) {
      try {
        const response = await fetch(callRecordingURL);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const blob = await response.blob();
        if (!blob || blob.size === 0) throw new Error("empty recording");
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `call Recording ${dayjs(new Date()).format(
          "MM/DD/YYYY hh:mm:ss",
        )}.mp3`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
        return;
      } catch (error) {
        console.error(`Download attempt ${attempt + 1} failed`, error);
        if (attempt < 4) await new Promise((r) => setTimeout(r, 2000));
      }
    }
    enqueueSnackbar("Recording download failed. Try again from call history.", {
      variant: "error",
    });
  };
  useEffect(() => {
    if (calllRecording !== null) {
      handleDownload(calllRecording);
    }
  }, [calllRecording]);

  // When the call ends from the OTHER side (RingCentral DISCONNECTED → "Call
  // Ended"), still fire the recording download if the user had flagged it.
  useEffect(() => {
    if (isRingCentralCall && (callStatus === "Call Ended" || callEnded)) {
      maybeDownloadRcRecording();
    }
  }, [callStatus, callEnded, isRingCentralCall]);
  // region Muted Mic

  const onToggleMute = async () => {
    if (isRingCentralCall || !activeConnection) {
      const nextMuted = !isMuted;
      dispatch(setIsMuted(nextMuted));
      if (isRingCentralCall) {
        try {
          await muteRingCentral(nextMuted);
        } catch (error) {
          dispatch(setIsMuted(!nextMuted));
          console.error("Failed to toggle RingCentral mute", error);
        }
      }
      return;
    }

    if (isMuted === false) {
      dispatch(setIsMuted(true));
      SendMute(
        activeConnection?.message?.To === undefined
          ? parseInt(
              activeConnection?.parameters?.From?.replace("client:", ""),
              10,
            )
          : activeConnection?.message?.To,
        parseInt(user_id),
        true,
      );
      activeConnection.mute(true);
    } else {
      dispatch(setIsMuted(false));
      SendMute(
        activeConnection?.message?.To === undefined
          ? parseInt(
              activeConnection?.parameters?.From?.replace("client:", ""),
              10,
            )
          : activeConnection?.message?.To,
        parseInt(user_id),
        false,
      );
      activeConnection.mute(false);
    }
  };

  const onToggleHold = async () => {
    if (!isRingCentralCall) return;

    const nextHold = !isOnHold;
    setIsOnHold(nextHold);
    try {
      await holdRingCentral(nextHold);
      setCallStatus(nextHold ? "On Hold" : "Connected");
    } catch (error) {
      setIsOnHold(!nextHold);
      console.error("Failed to toggle RingCentral hold", error);
    }
  };

  const onToggleCamera = () => {
    if (isCamera === false) {
      setIsCamera(true);
    } else {
      setIsCamera(false);
    }
  };

  // Posting AddUserCallRecordsAPIdata

  const inappPostedData = {
    CallId: 0,
    callType: "Single",
    callTitle: activeConnection?.message?.CallerName,
    CreatedBy: parseInt(user_id),
    STARTTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(callStartTime).format("HH:mm:ss.") +
          dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
    ENDTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(new Date()).format("HH:mm:ss.") +
          dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
    CALLSTATUS: callDuration == 0 ? "Busy" : "Completed",
    DURATION:
      callDuration == 0
        ? 0
        : calculateCallDuration(
            dayjs(new Date()).format("HH:mm:ss.") +
              dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
            dayjs(callStartTime).format("HH:mm:ss.") +
              dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
          ),
    ConversationId: chat_Id || sendCallChatId,
    callParticipants: [
      {
        userId: parseInt(user_id),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse: activeConnection?.direction,
        IsSeen:
          activeConnection?.direction == "OUTGOING" && callDuration == 0
            ? true
            : false,
      },
      {
        userId:
          activeConnection?.message?.To ||
          parseInt(activeConnection?.parameters?.From?.split(":")[1]),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse:
          activeConnection?.direction == "OUTGOING" ? "INCOMING" : "OUTGOING",
        IsSeen:
          activeConnection?.direction == "INCOMING" && callDuration == 0
            ? true
            : false,
      },
    ],
  };

  // second Object For ExternalNumberCalling

  const outboundPostedData = {
    CallId: 0,
    callType: "Single",
    callTitle: "nothing",
    CreatedBy: parseInt(user_id),
    STARTTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(callStartTime).format("HH:mm:ss.") +
          dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
    ENDTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(new Date()).format("HH:mm:ss.") +
          dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
    CALLSTATUS: callDuration == 0 ? "Busy" : "Completed",
    DURATION:
      callDuration == 0
        ? 0
        : calculateCallDuration(
            dayjs(new Date()).format("HH:mm:ss.") +
              dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
            dayjs(callStartTime).format("HH:mm:ss.") +
              dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
          ),
    callParticipants: [
      {
        userId: parseInt(user_id),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse: activeConnection?.direction,
        ExternalPersonContactNo:
          activeConnection?.direction === "OUTGOING" &&
          typeof activeConnection?.message?.To === "string" &&
          activeConnection?.message?.To.startsWith("+")
            ? activeConnection.message.To
            : dialingNumber,
        CreatedBy: parseInt(user_id),
        IsSeen: true,
      },
    ],
  };

  const inboundPostedData = {
    CallId: 0,
    callType: "Single",
    callTitle: "nothing",
    CreatedBy: parseInt(user_id),
    STARTTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(callStartTime).format("HH:mm:ss.") +
          dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
    ENDTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(new Date()).format("HH:mm:ss.") +
          dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
    CALLSTATUS: callDuration == 0 ? "Busy" : "Completed",
    DURATION:
      callDuration == 0
        ? 0
        : calculateCallDuration(
            dayjs(new Date()).format("HH:mm:ss.") +
              dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
            dayjs(callStartTime).format("HH:mm:ss.") +
              dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
          ),
    callParticipants: [
      {
        userId: parseInt(user_id),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse: activeConnection?.direction,
        ExternalPersonContactNo: activeConnection?.parameters?.From,
        CreatedBy: parseInt(user_id),
        IsSeen: true,
      },
    ],
  };
  //region addCallRecords
  const addCallRecordsApi = async () => {
    if (
      (activeConnection?.direction == "OUTGOING" &&
        typeof activeConnection?.message?.To === "string" &&
        activeConnection?.message?.To?.startsWith("+")) ||
      dialingNumber
    ) {
      await addCallRecords(outboundPostedData);
      setCallEnded(true);
    } else if (
      activeConnection?.direction == "INCOMING" &&
      activeConnection?.parameters?.From?.startsWith("+")
    ) {
      await addCallRecords(inboundPostedData);
      setCallEnded(true);
    } else {
      if (inappPostedData) {
        let timer = setTimeout(async () => {
          const resp = await addCallRecords(inappPostedData);
          const respForAddCount = await getMissedCallCount(user_id);
          if (respForAddCount?.status == 200) {
            dispatch(setMissedCallCount(respForAddCount?.data?.count));
            dispatch(
              setMissedCallParticipantId(
                respForAddCount?.data?.result
                  ?.map((data) => data?.cp?.callParticipantId)
                  ?.toString(),
              ),
            );
          }
          setCallLogsCallId(resp?.data?.result?.callId);
          if (resp?.data?.result?.callId) {
            newCallLogs(resp?.data?.result?.callId);
          }
          setCallEnded(true);
        }, 300);
        return () => clearTimeout(timer);
      }
    }
  };

  // Screen Sharing Button

  const onToggleScreenShare = () => {
    if (!isSharing) {
      startScreenShare();
    } else {
      stopScreenShare();
      cleanupRoom();
    }
  };

  const onEndCall = async () => {
    dispatch(setUserById(null));
    dispatch(setContactImage(null));
    try {
      if (getSelectedCallProvider() === "RingCentral") {
        // If the user flagged this call for recording, fetch & download it once
        // the call ends (the automatic recording finalizes a few seconds later).
        maybeDownloadRcRecording();
        await hangupRingCentral();
        setCallStatus("");
        setCallAccepted(false);
        setActiveConnection(null);
        setCallDuration(0);
        setIsCallActive(false);
        dispatch(setAudioCallStart(false));
        dispatch(setShowChatSectionDuringCall(false));
        dispatch(setCallRunningInBG(false));
        dispatch(setIsReceiveMuted([]));
        dispatch(setIsReceiveRecording([]));
        dispatch(setDialingNumber(""));
        dispatch(setIsMuted(false));
        setIsOnHold(false);
        setPendingRequests([]);
        setParticipants([]);
        // ✅ Navigate karo
        setTimeout(() => navigate("/chats"), 500);
        return; // ✅ Yahan return karo
      } else if (activeConnection) {
        activeConnection.disconnect();
        if (!userOffline) {
          addCallRecordsApi();
        }
      }
      setActiveConnection(null);
      setCallAccepted(false);
      setCallDuration(0);
      setIsCallActive(false);
      setCallStatus("Call Ended");
    } catch (error) {
      console.error("Failed to end call", error);
    }
    stopScreenShare();
    cleanupRoom();
    dispatch(setAudioCallStart(false));
    dispatch(setShowChatSectionDuringCall(false));
    dispatch(setCallRunningInBG(false));
    dispatch(setIsReceiveMuted([]));
    dispatch(setIsReceiveRecording([]));
    setCallDuration(0);
    dispatch(setDialingNumber(""));
    dispatch(setIsMuted(false));
    setIsOnHold(false);
    setCallStatus("");
    setPendingRequests([]);
    setParticipants([]);
  };

  useEffect(() => {
    if (callAccepted === true) {
      // Do NOT reset callDuration here. This effect also runs on every REMOUNT
      // (e.g. navigating back via "Go To Call") while callAccepted is already
      // true, which used to zero the running timer. The duration is already 0 at
      // dial and only counts while status is "Connected", so it starts fresh at
      // pickup without an explicit reset — and stays continuous across remounts.
      setCallStatus("Connected");
    }
  }, [callAccepted]);

  useEffect(() => {
    if (callStatus !== "On Hold") {
      setIsOnHold(false);
    }
  }, [callStatus]);

  // Format duration to MM:SS
  const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0",
    )}`;
  };

  // region Screen Sharing
  // const startScreenShare = async () => {
  //   debugger;
  //   if (isScreenSharing) return;

  //   try {
  //     console.log("Fetching screen sources...");
  //     const sources = await window.electronAPI.getScreenSources();
  //     if (!sources.length) {
  //       throw new Error("No screen sources available");
  //     }

  //     // Allow user to select a screen source (defaulting to the first one)
  //     const sourceId = sources[0]?.id;
  //     if (!sourceId) throw new Error("Invalid screen source ID");

  //     console.log("Selected screen source ID:", sourceId);

  //     console.log("Requesting screen stream...");
  //     const stream = await window.electronAPI.getScreenStream(sourceId);
  //     if (!stream) throw new Error("Failed to get screen stream");

  //     console.log("Screen stream obtained:", stream);

  //     const screenTrack = stream.getTracks()[0];
  //     if (!screenTrack) {
  //       throw new Error("No video track found in screen stream");
  //     }

  //     const twilioScreenTrack = new LocalVideoTrack(screenTrack);
  //     localScreenTrackRef.current = twilioScreenTrack;

  //     if (localMediaRef.current) {
  //       localMediaRef.current.innerHTML = "";
  //       localMediaRef.current.appendChild(twilioScreenTrack.attach());
  //     }

  //     if (!room) {
  //       const senderId = user_id;
  //       const receiverId =
  //         activeConnection?.message?.To ||
  //         parseInt(
  //           activeConnection?.parameters?.From?.replace("client:", ""),
  //           10
  //         );
  //       const uniqueRoomName = generateRoomName(senderId, receiverId);
  //       console.log("Generating Twilio token for room:", uniqueRoomName);

  //       const response = await getVideoCallToken(senderId, uniqueRoomName);
  //       const token = response?.data?.token;
  //       if (!token) {
  //         throw new Error("Failed to get Twilio token");
  //       }

  //       console.log("Connecting to Twilio room...");
  //       const connectedRoom = await connect(token, {
  //         name: uniqueRoomName,
  //         video: false,
  //       });

  //       console.log("Publishing screen track to room...");
  //       connectedRoom.localParticipant.publishTrack(twilioScreenTrack);

  //       setRoom(connectedRoom);
  //       setIsScreenSharing(true);
  //       setIsSharing(true);

  //       SendShareScreen(
  //         receiverId,
  //         parseInt(user_id),
  //         activeConnection?.parameters?.CallSid,
  //         true,
  //         uniqueRoomName
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Failed to start screen sharing: ", error);
  //     // alert(`Screen sharing failed: ${error.message}`);
  //   }
  // };

  // const startScreenShare = async () => {
  //   if (isScreenSharing) return;
  //   try {
  //     const sources = window.electronAPI
  //       ? await window.electronAPI.getScreenSources()
  //       : [];
  //     const sourceId = sources[0]?.id;
  //     const stream =
  //       (await navigator.mediaDevices.getDisplayMedia({
  //         video: {
  //           cursor: "always",
  //           displaySurface: "monitor",
  //           selfBrowserSurface: "exclude",
  //           logicalSurface: true,
  //         },
  //       })) || (await window.electronAPI.getScreenStream(sourceId));
  //     const screenTrack = stream.getTracks()[0];
  //     const twilioScreenTrack = new LocalVideoTrack(screenTrack);
  //     localScreenTrackRef.current = twilioScreenTrack;

  //     if (localMediaRef.current) {
  //       localMediaRef.current.innerHTML = "";
  //       localMediaRef.current.appendChild(twilioScreenTrack.attach());
  //     }

  //     if (!room) {
  //       setIsLoading(true);
  //       const senderId = user_id;
  //       const receiverId =
  //         activeConnection?.message?.To ||
  //         parseInt(
  //           activeConnection?.parameters?.From?.replace("client:", ""),
  //           10
  //         );
  //       const uniqueRoomName = generateRoomName(senderId, receiverId);
  //       const response = await getVideoCallToken(senderId, uniqueRoomName);
  //       const token = response?.data?.token;
  //       const connectedRoom = await connect(token, {
  //         name: uniqueRoomName,
  //         video: false,
  //       });
  //       // Publish screen track
  //       connectedRoom.localParticipant.publishTrack(twilioScreenTrack);

  //       setRoom(connectedRoom);
  //       setTimeout(() => {
  //         setIsScreenSharing(true);
  //         setIsLoading(false);
  //         setIsSharing(true);
  //       }, 9000);

  //       // Notify receiver to join the room
  //       SendShareScreen(
  //         receiverId,
  //         parseInt(user_id),
  //         activeConnection?.parameters?.CallSid,
  //         true,
  //         uniqueRoomName
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Failed to start screen sharing: ", error);
  //   }
  // };

  const startScreenShare = async () => {
    if (isScreenSharing) return;

    try {
      setIsLoading(true);

      const sources = window.electronAPI
        ? await window.electronAPI.getScreenSources()
        : [];
      const sourceId = sources[0]?.id;
      // const stream =
      //   (await navigator.mediaDevices.getDisplayMedia({
      //     video: {
      //       cursor: "always",
      //       displaySurface: "monitor",
      //       selfBrowserSurface: "exclude",
      //       logicalSurface: true,
      //     },
      //   })) || (await window.electronAPI.getScreenStream(sourceId));

      const stream =
        (await navigator.mediaDevices.getDisplayMedia({
          video: {
            cursor: "always",
          },
          audio: false,
        })) || (await window.electronAPI.getScreenStream(sourceId));

      const screenTrack = stream.getTracks()[0];

      // Handle when user stops screen sharing via browser popup
      screenTrack.onended = () => {
        stopScreenShare();
        setIsSharing(false);
        setIsScreenSharing(false);
      };

      const twilioScreenTrack = new LocalVideoTrack(screenTrack);
      localScreenTrackRef.current = twilioScreenTrack;

      // Attach to local preview
      if (localMediaRef.current) {
        localMediaRef.current.innerHTML = "";
        localMediaRef.current.appendChild(twilioScreenTrack.attach());
      }

      if (!room) {
        const senderId = user_id;
        const receiverId =
          activeConnection?._direction === "INCOMING"
            ? parseInt(
                activeConnection?.parameters?.From?.replace("client:", ""),
                10,
              )
            : parseInt(activeConnection?.customParameters?.get("To"), 10);

        const uniqueRoomName = generateRoomName(senderId, receiverId);

        const response = await getVideoCallToken(senderId, uniqueRoomName);
        const token = response?.data?.token;

        const connectedRoom = await connect(token, {
          name: uniqueRoomName,
          video: false,
        });

        // const connectedRoom = await connect(token, {
        //   name: uniqueRoomName,
        //   video: false,
        //   bandwidthProfile: {
        //     video: {
        //       mode: "presentation",
        //       maxTracks: 1,
        //     },
        //   },
        //   preferredVideoCodecs: [{ codec: "VP8", simulcast: false }],
        // });

        // Publish screen track to Twilio
        connectedRoom.localParticipant.publishTrack(twilioScreenTrack);
        setRoom(connectedRoom);
        setIsScreenSharing(true);
        setIsSharing(true);
        setIsLoading(false);

        // Notify receiver to join room
        SendShareScreen(
          receiverId,
          parseInt(user_id),
          activeConnection?.parameters?.CallSid,
          true,
          uniqueRoomName,
        );
      }
    } catch (error) {
      console.error("Failed to start screen sharing: ", error);

      // If user cancels screen share popup or error occurs
      setIsLoading(false);
      setIsScreenSharing(false);
      setIsSharing(false);
    }
  };

  const stopScreenShare = () => {
    if (room) {
      if (localScreenTrackRef.current) {
        localScreenTrackRef.current.stop();
        room.localParticipant.unpublishTrack(localScreenTrackRef.current);
        localScreenTrackRef.current = null;
      }

      room.participants.forEach((participant) => {
        participant.tracks.forEach((publication) => {
          if (publication.track && publication.track.kind === "video") {
            const attachedElements = publication.track.detach();
            attachedElements.forEach((element) => element.remove());
            publication.track.stop();
          }
        });
      });

      room.localParticipant.tracks.forEach((publication) => {
        if (publication.track) {
          publication.track.stop();
          publication.unpublish();
        }
      });

      room.participants.forEach((participant) => {
        participant.tracks.forEach((publication) => {
          if (publication.track) {
            const attachedElements = publication.track.detach();
            attachedElements.forEach((element) => element.remove());
            publication.track.stop();
          }
        });
      });

      room.disconnect();
    }

    const senderId = user_id;
    const receiverId =
      activeConnection?.message?.To ||
      parseInt(activeConnection?.parameters?.From?.replace("client:", ""), 10);
    const uniqueRoomName = generateRoomName(senderId, receiverId);

    SendShareScreen(
      receiverId,
      parseInt(user_id),
      activeConnection?.parameters?.CallSid,
      false,
      uniqueRoomName,
    );
    // Clean up DOM elements
    if (localMediaRef.current) localMediaRef.current.innerHTML = "";
    if (remoteMediaRef.current) remoteMediaRef.current.innerHTML = "";

    // Reset room state
    setRoom(null);
    setIsScreenSharing(false);
    setIsSharing(false);
    setIsLoading(false);
  };

  const cleanupRoom = () => {
    if (room) {
      // Clean up local participant
      room.localParticipant.tracks.forEach((publication) => {
        if (publication.track) {
          publication.track.stop();
          publication.unpublish();
        }
      });

      // Clean up remote participants
      room.participants.forEach((participant) => {
        participant.tracks.forEach((publication) => {
          if (publication.track) {
            const attachedElements = publication.track.detach();
            attachedElements.forEach((element) => element.remove()); // Remove DOM elements
            publication.track.stop(); // Stop the track
          }
        });
      });
      room.disconnect();
    }
    // Clean up DOM elements
    if (localMediaRef.current) localMediaRef.current.innerHTML = "";
    if (remoteMediaRef.current) remoteMediaRef.current.innerHTML = "";

    // Reset state
    setRoom(null);
    setIsScreenSharing(false);
    setIsSharing(false);
    setIsLoading(false);
  };

  const addRemoteParticipantTracks = (participant) => {
    participant.tracks.forEach((publication) => {
      if (publication.isSubscribed && publication.track.kind === "video") {
        attachTrack(publication.track);
      }
    });

    participant.on("trackPublished", (publication) => {
      if (publication.kind === "video") {
        publication.on("subscribed", (track) => {
          if (track.kind === "video") {
            attachTrack(track);
          }
        });
      }
    });

    participant.on("trackSubscribed", (track) => {
      if (track.kind === "video") {
        attachTrack(track);
      }
    });

    participant.on("trackUnsubscribed", (track) => {
      if (track.kind === "video" || track.kind === "audio") {
        if (remoteMediaRef.current) {
          const attachedElements = track.detach();
          attachedElements.forEach((element) => element.remove());
        }
      }
    });
  };

  const attachTrack = (track) => {
    const videoElement = track.attach();
    videoElement.style.width = "100%";
    videoElement.style.height = "100%";
    videoElement.style.objectFit = "contain";
    if (remoteMediaRef.current) {
      remoteMediaRef.current.innerHTML = "";
      remoteMediaRef.current.appendChild(videoElement);
    }
  };

  const removeRemoteParticipantTracks = (participant) => {
    participant.tracks.forEach((publication) => {
      if (publication.track && publication.track.detach) {
        const attachedElements = publication.track.detach();
        attachedElements.forEach((element) => element.remove());
      }
    });
  };

  const joinRoom = async (isShareScreen) => {
    try {
      if (!room) {
        const response = await getVideoCallToken(
          isShareScreen?.CallId,
          isShareScreen?.RoomName,
        );
        const token = response.data.token;
        const connectedRoom = await connect(token, {
          room: isShareScreen?.RoomName,
          video: false,
          maxReconnectAttempts: 10,
          maxReconnectTime: 300000,
          networkQuality: {
            local: 3,
            remote: 3,
          },
        });

        const handleNetworkQualityChanged = (participant, level) => {
          if (level <= 1) {
            handleReconnecting(participant);
          } else {
            handleReconnected(participant);
          }
        };

        const handleReconnecting = () => {
          setIsReconnecting(true);
          // emitReconnectingStatus(true);
        };

        const handleReconnected = () => {
          setIsReconnecting(false);
          // emitReconnectingStatus(false);
        };

        connectedRoom.on("reconnecting", () => handleReconnecting());
        connectedRoom.on("reconnected", () => handleReconnected());

        connectedRoom.participants.forEach((participant) => {
          // addRemoteParticipantTracks(participant);
          if (participant.identity == isShareScreen?.UserId) {
            addRemoteParticipantTracks(participant);
            participant.on("networkQualityLevelChanged", (level) => {
              handleNetworkQualityChanged(participant, level);
            });
            participant.on("reconnecting", () => handleReconnecting());
            participant.on("reconnected", () => handleReconnected());
          }
        });

        connectedRoom.on("participantConnected", (participant) => {
          // addRemoteParticipantTracks(participant);
          if (participant.identity == isShareScreen?.UserId) {
            addRemoteParticipantTracks(participant);
            participant.on("networkQualityLevelChanged", (level) => {
              handleNetworkQualityChanged(participant, level);
            });
            connectedRoom.on("reconnecting", () =>
              handleReconnecting(participant),
            );
            connectedRoom.on("reconnected", () =>
              handleReconnected(participant),
            );
          }
        });

        connectedRoom.on("disconnected", () => {
          if (localMediaRef.current) localMediaRef.current.innerHTML = "";
          if (remoteMediaRef.current) remoteMediaRef.current.innerHTML = "";
          setRoom(null);
          cleanupRoom();
        });

        connectedRoom.on("participantDisconnected", (participant) => {
          if (participant) {
            removeRemoteParticipantTracks(participant);
          }
        });
        setRoom(connectedRoom);
        localParticipant.current = connectedRoom.localParticipant;
      }
    } catch (error) {
      console.error(`Unable to connect to the room: ${error.message}`);
    }
  };

  useEffect(() => {
    let currentRoom = room;

    const cleanup = () => {
      if (currentRoom) {
        currentRoom.disconnect();
        if (localMediaRef.current) localMediaRef.current.innerHTML = "";
        if (remoteMediaRef.current) remoteMediaRef.current.innerHTML = "";
        setRoom(null);
      }
    };

    if (isShareScreen?.CallId == user_id && isShareScreen?.IsStream) {
      joinRoom(isShareScreen);
    }
    return cleanup;
  }, [user_id, isShareScreen, room]);

  // Notify Recording & muted

  useEffect(() => {
    const fetchToken = async (isReceiveMuted, isReceiveRecording) => {
      try {
        const response = await getUsersById(
          isReceiveMuted?.UserId || isReceiveRecording?.UserId,
        );
        setNameMuted(response?.data?.result?.[0]);
      } catch (error) {
        console.log(`Error:`, error);
      }
    };
    if (isReceiveMuted?.UserId || isReceiveRecording?.UserId) {
      fetchToken(isReceiveMuted, isReceiveRecording);
    }
  }, [isReceiveMuted, isReceiveRecording]);

  // For user Offline

  const userOfflinePostedData = {
    CallId: 0,
    callType: "Single",
    callTitle: activeConnection?.message?.CallerName
      ? activeConnection?.message?.CallerName.slice(0, 11)
      : "User",
    CreatedBy: parseInt(user_id),
    STARTTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(callStartTime).format("HH:mm:ss.") +
          dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
    ENDTIME:
      callDuration == 0
        ? "00:00:00.0000000"
        : dayjs(new Date()).format("HH:mm:ss.") +
          dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
    CALLSTATUS: callDuration == 0 ? "Busy" : "Completed",
    DURATION:
      callDuration == 0
        ? 0
        : calculateCallDuration(
            dayjs(new Date()).format("HH:mm:ss.") +
              dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
            dayjs(callStartTime).format("HH:mm:ss.") +
              dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
          ),

    ConversationId: chat_Id || sendCallChatId,
    callParticipants: [
      {
        userId: parseInt(user_id),
        joinedAt:
          dayjs(callStartTime).format("HH:mm:ss.") +
          dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
        callResponse: activeConnection?.direction,
        IsSeen:
          activeConnection?.direction == "OUTGOING" && callDuration == 0
            ? true
            : false,
      },
      {
        userId:
          activeConnection?.message?.To ||
          parseInt(activeConnection?.parameters?.From?.split(":")[1]),
        joinedAt:
          dayjs(callStartTime).format("HH:mm:ss.") +
          dayjs(callStartTime).millisecond().toString().padEnd(7, "0"),
        callResponse:
          activeConnection?.direction == "OUTGOING" ? "INCOMING" : "OUTGOING",
        IsSeen:
          activeConnection?.direction == "INCOMING" && callDuration == 0
            ? true
            : false,
      },
    ],
  };
  const handleUserOffline = async () => {
    try {
      const resp = await addCallRecords(userOfflinePostedData);
    } catch (error) {
      console.error("Error while adding call records:", error);
    }
  };
  useEffect(() => {
    if (userOffline) {
      let timer = setTimeout(() => {
        handleUserOffline();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [userOffline]);

  // For Outbound Calling Status Change

  useEffect(() => {
    if (
      activeConnection &&
      typeof activeConnection?.message?.To === "string" &&
      activeConnection?.message?.To?.startsWith("+")
    ) {
      if (callStatus === "") {
        setTimeout(() => {
          setCallStatus("Connected");
        }, 37000);
      }
    }
  }, [activeConnection, callStatus]);

  useEffect(() => {
    if (activeConnection) {
      const from = activeConnection?.customParameters?.get("From");
      const getCallSid = (conn) => {
        return (
          activeConnection?.parameters?.CallSid ||
          activeConnection?._mediaHandler?.callSid ||
          activeConnection?.outboundConnectionId
        );
      };
      const callSid = getCallSid();

      if (from) {
        SetCallSid(from, callSid);
      }
    }
  }, [activeConnection]);

  return (
    <>
      {showParticipantUI === true ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100vh",
            backgroundImage: `url(${CallScreenBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            bgcolor: "#2A2A36",
            padding: "10px",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "90%",
              height: "80vh",
              overflow: "hidden",
              boxSizing: "border-box",
            }}
          >
            <Box sx={renderVideoLayout()}>
              {/* Connected Participants */}
              {participants?.map((user) => (
                <Box
                  key={user.id}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #000",
                    borderRadius: "8px",
                    backgroundColor: generateColorFromString(user.name),
                    aspectRatio: "16/9",
                    position: "relative",
                  }}
                >
                  <Avatar
                    src={user.avatar ? `${s.baseUrl}${user.avatar}` : null}
                    sx={{ width: boxSize / 2, height: boxSize / 2 }}
                  />
                  <Typography variant="body1" color="white" textAlign="center">
                    {user.name}
                  </Typography>
                </Box>
              ))}

              {/* Pending Requests with Loading */}
              {/* {pendingRequests.map((user) => (
                <Box
                  key={user.id}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #000",
                    borderRadius: "8px",
                    backgroundColor: generateColorFromString(
                      user.firstName + user?.lastName
                    ),
                    aspectRatio: "16/9",
                    position: "relative",
                  }}
                >
                  <Avatar
                    src={`${s.baseUrl}${user.profilePic}`}
                    sx={{ width: boxSize / 2, height: boxSize / 2 }}
                  />
                  <Typography variant="body1" color="white" textAlign="center">
                    {user.firstName + " " + user?.lastName}
                  </Typography>
                  <CircularProgress size={20} sx={{ mt: 1 }} />
                </Box>
              ))} */}

              {pendingRequests?.map((user) => (
                <Box
                  key={user.id}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #000",
                    borderRadius: "8px",
                    backgroundColor: generateColorFromString(
                      user.firstName + user?.lastName,
                    ),
                    aspectRatio: "16/9",
                    position: "relative",
                    filter: user.joined ? "none" : "blur(0.5px)",
                    transition: "filter 0.3s ease-in-out",
                  }}
                >
                  <Avatar
                    src={`${s.baseUrl}${user.profilePic}`}
                    sx={{ width: boxSize / 2, height: boxSize / 2 }}
                  />
                  <Typography variant="body1" color="white" textAlign="center">
                    {user.firstName + " " + user?.lastName}
                  </Typography>

                  {/* ✅ Loading Indicator in Center */}
                  {!user.joined && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(0, 0, 0, 0.5)",
                        borderRadius: "8px",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <CircularProgress size={40} sx={{ color: "white" }} />
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              width: "95%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", gap: 2 }}>
              <Tooltip title="Chat" placement="top">
                <IconButton
                  onClick={() => {
                    if (showChatSectionDuringCall) {
                      dispatch(setShowChatSectionDuringCall(false));
                    } else {
                      dispatch(setShowChatSectionDuringCall(true));
                    }
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "50%",
                      width: 33,
                      height: 33,
                      border: "1px solid #1E1F24",
                      backgroundColor: "#1E1F24",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={chatIcon}
                      alt="Chat Icon"
                      style={{ width: 23, height: 23 }}
                    />
                  </Box>
                </IconButton>
              </Tooltip>
              {isRingCentralCall && (
                <Tooltip title={isOnHold ? "Resume" : "Hold"} placement="top">
                  <span>
                    <IconButton
                      color="primary"
                      onClick={onToggleHold}
                      disabled={
                        callStatus !== "Connected" && callStatus !== "On Hold"
                      }
                      sx={{
                        "&:hover": {
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        },
                        "&.Mui-focusVisible": {
                          boxShadow: "none",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          borderRadius: "50%",
                          width: 33,
                          height: 33,
                          border: "1px solid #1E1F24",
                          backgroundColor: "#1E1F24",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {isOnHold ? (
                          <PlayArrowRoundedIcon
                            style={{
                              width: 23,
                              height: 23,
                              color: "#818090",
                            }}
                          />
                        ) : (
                          <PauseRoundedIcon
                            style={{
                              width: 23,
                              height: 23,
                              color: "#818090",
                            }}
                          />
                        )}
                      </Box>
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Tooltip
                title={isCamera === true ? "Stop" : "Video"}
                placement="top"
              >
                <IconButton
                  color="primary"
                  onClick={onToggleCamera}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  {isCamera === false ? (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VideocamOffRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VideocamRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  )}
                </IconButton>
              </Tooltip>
              <Tooltip title="End" placement="top">
                <IconButton
                  color="error"
                  onClick={() => {
                    if (showParticipantUI) {
                      endConferenceCall();
                    }
                  }}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "50%",
                      width: 33,
                      height: 33,
                      border: "1px solid #FD372A",
                      backgroundColor: "#FD372A",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CallEndRoundedIcon
                      style={{ width: 23, height: 23, color: "#F9F9F9" }}
                    />
                  </Box>
                </IconButton>
              </Tooltip>
              <Tooltip
                title={isMuted === true ? "Unmute" : "Mute"}
                placement="top"
              >
                <IconButton
                  color="primary"
                  onClick={onToggleMute}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  {isMuted === true ? (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MicOffRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MicRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  )}
                </IconButton>
              </Tooltip>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Tooltip title="Add Participants" placement="top">
                <IconButton>
                  <Box
                    sx={{
                      borderRadius: "50%",
                      width: 33,
                      height: 33,
                      border: "1px solid #1E1F24",
                      backgroundColor: "#1E1F24",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={handleAddParticipantOpen}
                  >
                    <img
                      src={AddPeople}
                      alt="Add People"
                      style={{ width: 20, height: 20 }}
                    />
                  </Box>
                </IconButton>
              </Tooltip>
              <Tooltip
                title={isScreenSharing === true ? "Stop" : "Sharing Screen"}
                placement="top"
              >
                <IconButton onClick={onToggleScreenShare}>
                  <Box
                    sx={{
                      borderRadius: "50%",
                      width: 33,
                      height: 33,
                      border: "1px solid #1E1F24",
                      backgroundColor: "#1E1F24",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {isScreenSharing === false ? (
                      <img
                        src={shareScreen}
                        alt="Screen Icon"
                        style={{ width: 20, height: 20 }}
                      />
                    ) : (
                      <StopCircleIcon sx={{ color: "#52a6e4" }} />
                    )}
                  </Box>
                </IconButton>
              </Tooltip>
              {/* RingCentral records every call automatically at the account
                  level, so the on-demand Record button is hidden for RC calls. */}
              {!isRingCentralCall && (
                <Tooltip
                  title={isRecording === true ? "Stop" : "Recording"}
                  placement="top"
                >
                  <IconButton onClick={onToggleRecording}>
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {isRecording === false ? (
                        <img
                          src={record}
                          alt="record"
                          style={{ width: 20, height: 20 }}
                        />
                      ) : (
                        <StopCircleIcon sx={{ color: "#52a6e4" }} />
                      )}
                    </Box>
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box display={"flex"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              height: "100vh",
              width: "100%",
              bgcolor: "#2A2A36",
              backgroundImage: `url(${CallScreenBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              pl: {
                xs: "45px",
                sm: "10px",
                md: "20px",
                lg: "40px",
                xl: "60px",
              },
              pr: {
                xs: "45px",
                sm: "10px",
                md: "20px",
                lg: "40px",
                xl: "60px",
              },
            }}
          >
            <Box
              height={"30px"}
              color={"white"}
              bgcolor={"transparent"}
              alignItems={"center"}
              marginRight={"4%"}
              sx={{
                width: {
                  xs: "120%",
                  sm: "99%",
                  md: "100%",
                  lg: "100%",
                  xl: "100%",
                },
              }}
            >
              <MenuIcon
                sx={{ color: "wheat", cursor: "pointer" }}
                onClick={() => {
                  // dispatch(setCallRunningInBG(true));
                  if (showChatSectionDuringCall) {
                    dispatch(setShowChatSectionDuringCall(false));
                  } else {
                    dispatch(setShowChatSectionDuringCall(true));
                  }
                }}
              />
            </Box>
            {/* For Remote Screen Share */}
            {isReconnecting ? (
              <Box
                sx={{
                  position: "absolute",
                  top: "30px",
                  bottom: "20px",
                  width: "93%",
                  height: "84vh",
                  marginBottom: 2,
                  zIndex: 1000,
                }}
              >
                <CircularProgress color="inherit" />
                <Typography sx={{ mt: 2 }}>
                  Poor network connection. Reconnecting...
                </Typography>
              </Box>
            ) : (
              <Box
                display={isShareScreen?.CallId == user_id ? "block" : "none"}
                ref={remoteMediaRef}
                sx={{
                  position: "absolute",
                  top: "30px",
                  bottom: "20px",
                  width: "93%",
                  height: "84vh",
                  marginBottom: 2,
                  zIndex: 1000,
                }}
              >
                <video
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transform: "scale(1)",
                  }}
                  autoPlay
                  playsInline
                />
              </Box>
            )}

            {/* For Remote Muted Box */}
            {isReceiveMuted && isReceiveMuted?.CallId == user_id && (
              <Box
                sx={{
                  position: "absolute",
                  top: "20px",
                  right: "10px",
                  width: "auto",
                  padding: "10px 20px",
                  backgroundColor: "black",
                  color: "white",
                  borderRadius: "5px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
                  display:
                    isReceiveMuted?.isMuted === true &&
                    isReceiveMuted?.CallId == user_id
                      ? "block"
                      : "none",
                  zIndex: 1000,
                  transition: "transform 0.5s ease, opacity 0.5s ease",
                  transform: isMuted ? "translateY(0)" : "translateY(100%)",
                  opacity:
                    isReceiveMuted?.isMuted === true &&
                    isReceiveMuted?.CallId == user_id
                      ? 1
                      : 0,
                }}
              >
                {isReceiveMuted?.isMuted === true &&
                  isReceiveMuted?.CallId == user_id && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span>{`${nameMuted?.firstName} ${nameMuted?.lastName} is Muted...`}</span>
                      <MicOffRoundedIcon
                        style={{ fontSize: "20px", color: "#818090" }}
                      />
                    </Box>
                  )}
              </Box>
            )}
            {/* For Local Muted Box */}
            {isMuted === true && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: "20px",
                  left: "80px",
                  width: "auto",
                  padding: "10px 20px",
                  backgroundColor: "black",
                  color: "white",
                  borderRadius: "5px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
                  display: isMuted === true ? "block" : "none",
                  zIndex: 1000,
                  transition: "transform 0.5s ease, opacity 0.5s ease",
                  transform: isMuted ? "translateY(0)" : "translateY(100%)",
                  opacity: isMuted === true ? 1 : 0,
                }}
              >
                {isMuted === true && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <span>{`Mic is Muted...`}</span>
                    <MicOffRoundedIcon
                      style={{ fontSize: "20px", color: "#818090" }}
                    />
                  </Box>
                )}
              </Box>
            )}
            {/* For Receiving Recording Box */}
            {isReceiveRecording && isReceiveRecording?.CallId == user_id && (
              <Box
                sx={{
                  position: "absolute",
                  top: "20px",
                  width: "auto",
                  padding: "10px 20px",
                  backgroundColor: "black",
                  color: "white",
                  borderRadius: "5px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
                  display:
                    isReceiveRecording?.IsRecord === true &&
                    isReceiveRecording?.CallId == user_id
                      ? "block"
                      : "none",
                  zIndex: 1000,
                  transition: "transform 0.5s ease, opacity 0.5s ease",
                  transform: isMuted ? "translateY(0)" : "translateY(100%)",
                  opacity:
                    isReceiveRecording?.IsRecord === true &&
                    isReceiveRecording?.CallId == user_id
                      ? 1
                      : 0,
                }}
              >
                {isReceiveRecording?.IsRecord === true &&
                  isReceiveRecording?.CallId == user_id && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <GraphicEqIcon
                        style={{ fontSize: "20px", color: "#818090" }}
                      />
                      <span>{` Recording started by ${nameMuted?.firstName} ${nameMuted?.lastName}`}</span>
                    </Box>
                  )}
              </Box>
            )}
            {/* For Sending Recording Box */}
            {isRecording && (
              <Box
                sx={{
                  position: "absolute",
                  top: "20px",
                  width: "auto",
                  padding: "10px 20px",
                  backgroundColor: "black",
                  color: "white",
                  borderRadius: "5px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
                  display: isRecording === true ? "block" : "none",
                  zIndex: 1000,
                  transition: "transform 0.5s ease, opacity 0.5s ease",
                  transform: isMuted ? "translateY(0)" : "translateY(100%)",
                  opacity: isRecording === true ? 1 : 0,
                }}
              >
                {isRecording === true && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <GraphicEqIcon
                      style={{ fontSize: "20px", color: "#818090" }}
                    />
                    <span>{` Recording start...`}</span>
                  </Box>
                )}
              </Box>
            )}
            {/* <Box
            ref={localMediaRef}
            sx={{
              position: "absolute",
              top: isScreenSharing ? "0" : "auto",
              right: 0,
              maxWidth: "300px",
              height: "50vh",
              aspectRatio: "16/9",
              backgroundColor: "black",
              overflow: "hidden",
              margin: 2,
              display: isScreenSharing ? "block" : "none",
              zIndex: 1000,
              transition: "top 0.5s ease, transform 0.5s ease",
              transform: isScreenSharing ? "translateY(0)" : "translateY(100%)",
            }}
          ></Box> */}
            {/* Caller Information */}
            <Box
              sx={{
                borderRadius: "50%",
                border: {
                  xs: "15px solid rgba(108, 108, 116, 0.9)",
                  sm: "22px solid rgba(108, 108, 116, 0.9)",
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  borderRadius: "50%",
                  border: {
                    xs: "10px solid #9A9A9F",
                    sm: "12px solid #9A9A9F",
                  },
                }}
              >
                <Avatar
                  sx={{
                    fontSize: "30px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    width: { xs: 80, sm: 100 },
                    height: { xs: 80, sm: 100 },
                    objectFit: "cover",
                  }}
                  alt="Profile"
                  src={
                    userById?.profilePicPath
                      ? `${s.baseUrl}${userById?.profilePicPath}`
                      : contactImage
                        ? `${s.baseUrl}${contactImage}`
                        : null
                  }
                  loading="lazy"
                >
                  {!userById?.profilePicPath && isRingCentralCall
                    ? (toCallingPersonName || dialingNumber || "?")
                        .charAt(0)
                        .toUpperCase()
                    : activeConnection?.parameters &&
                        typeof activeConnection?.parameters?.From == "string" &&
                        activeConnection?.parameters?.From?.startsWith("+")
                      ? `${activeConnection?.parameters?.From?.slice(0, 2)}`
                      : activeConnection?.parameters &&
                          typeof activeConnection?.message?.To === "string" &&
                          activeConnection?.message?.To?.startsWith("+")
                        ? `${activeConnection?.message?.To?.slice(0, 2)}`
                        : callerName && callerName.charAt(0)}
                </Avatar>
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: "center",
                fontFamily: "Poppins",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "550",
                  color: "#FFFFFF",
                  fontSize: {
                    xs: "12px",
                    sm: "14px",
                    md: "14px",
                    lg: "14px",
                    xl: "22px",
                  },
                }}
              >
                {isRingCentralCall
                  ? toCallingPersonName || dialingNumber
                  : (activeConnection?.parameters &&
                        typeof activeConnection?.parameters?.From ===
                          "string" &&
                        activeConnection?.parameters?.From?.startsWith("+")) ||
                      (typeof activeConnection?.message?.To === "string" &&
                        activeConnection?.message?.To?.startsWith("+"))
                    ? activeConnection?.parameters?.From?.startsWith("+")
                      ? activeConnection.parameters.From
                      : activeConnection.message.To
                    : userById?.firstName && userById?.lastName
                      ? `${userById.firstName} ${userById.lastName}`
                      : activeConnection?.customParameters?.get("Direction") ===
                          "outbound"
                        ? activeConnection?.customParameters?.get("To")
                        : activeConnection?.customParameters?.get(
                              "Direction",
                            ) === "inapp"
                          ? callerName
                          : ""}
              </Typography>
              {callStatus === "Connected" && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "#F3F3F3",
                    marginTop: "2px",
                    fontWeight: "400",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "14px",
                      xl: "22px",
                    },
                  }}
                >
                  {formatDuration(callDuration)}
                </Typography>
              )}

              {/* {callStatus && ( */}
              <Typography
                variant="body2"
                sx={{
                  color: "#B0B0B0",
                  fontSize: {
                    xs: "12px",
                    sm: "15px",
                    md: "14px",
                    lg: "14px",
                    xl: "22px",
                  },
                  marginTop: "5px",
                  fontWeight: "400",
                }}
              >
                {callStatus}
              </Typography>
              {/* )} */}
            </Box>
            {/* Action Buttons */}
            <Box
              sx={{
                mt: { xs: "2rem", sm: "5rem" },
                mb: { xs: "1rem", sm: "1.5rem" },
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                pl: "10px",
                pr: "10px",
              }}
            >
              {/* Left Box */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  color: "#B0B0B0",
                  fontFamily: "Poppins",
                  textAlign: "center",
                  mb: { xs: "1rem", sm: "0" },
                }}
              >
                <IconButton
                  color="primary"
                  // onClick={onChatMenu}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "50%",
                      width: 33,
                      height: 33,
                      border: "1px solid #1E1F24",
                      backgroundColor: "#1E1F24",
                      overflow: "hidden",
                      display: "none",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={chatIcon}
                      alt="Chat Icon"
                      style={{ width: 23, height: 23 }}
                    />
                  </Box>
                </IconButton>
                <Typography
                  sx={{ fontSize: { xs: "10px", sm: "12px" }, display: "none" }}
                >
                  Chat
                </Typography>
              </Box>
              {/* Center Box */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  color: "#B0B0B0",
                  fontFamily: "Poppins",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  marginLeft: { xs: "0", sm: "13rem" },
                  gap: 2,
                  mb: { xs: "1rem", sm: "0" },
                }}
              >
                <IconButton
                  color="primary"
                  onClick={onToggleCamera}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  {isCamera === false ? (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VideocamOffRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VideocamRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  )}
                </IconButton>
                <IconButton
                  color="error"
                  onClick={() => {
                    onEndCall();
                  }}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "50%",
                      width: 33,
                      height: 33,
                      border: "1px solid #FD372A",
                      backgroundColor: "#FD372A",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CallEndRoundedIcon
                      style={{ width: 23, height: 23, color: "#F9F9F9" }}
                    />
                  </Box>
                </IconButton>
                <IconButton
                  color="primary"
                  onClick={onToggleMute}
                  sx={{
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focusVisible": {
                      boxShadow: "none",
                    },
                  }}
                >
                  {isMuted === true ? (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MicOffRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MicRoundedIcon
                        style={{ width: 23, height: 23, color: "#818090" }}
                      />
                    </Box>
                  )}
                </IconButton>
                {isRingCentralCall && (
                  <IconButton
                    color="primary"
                    onClick={onToggleHold}
                    disabled={
                      callStatus !== "Connected" && callStatus !== "On Hold"
                    }
                    sx={{
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      },
                      "&.Mui-focusVisible": {
                        boxShadow: "none",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {isOnHold ? (
                        <PlayArrowRoundedIcon
                          style={{ width: 23, height: 23, color: "#818090" }}
                        />
                      ) : (
                        <PauseRoundedIcon
                          style={{ width: 23, height: 23, color: "#818090" }}
                        />
                      )}
                    </Box>
                  </IconButton>
                )}
                {(isRingCentralCall ||
                  activeConnection?._options?.twimlParams?.Direction ==
                    "outbound") && (
                  <IconButton
                    onClick={handleDialModalOpen}
                    // color="primary"
                    sx={{
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      },
                      "&.Mui-focusVisible": {
                        boxShadow: "none",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        // border: "1px solid #FD372A",
                        backgroundColor: "#ffffff",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <KeyboardHideIcon
                        style={{ width: 23, height: 23, color: "#7D827F" }}
                      />
                    </Box>
                  </IconButton>
                )}
              </Box>

              {/* Right Box */}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  color: "#B0B0B0",
                  fontFamily: "Poppins",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    justifyContent: "center",
                    color: "#B0B0B0",
                    fontFamily: "Poppins",
                  }}
                >
                  {isLoading ? (
                    <CircularProgress
                      size={30}
                      sx={{ color: "#085F99", marginTop: "1rem" }}
                    />
                  ) : (
                    <>
                      <IconButton
                        color="primary"
                        onClick={onToggleScreenShare}
                        sx={{
                          "&:hover": {
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          },
                          "&.Mui-focusVisible": {
                            boxShadow: "none",
                          },
                        }}
                        disabled={
                          (activeConnection && !activeConnection?.message
                            ? false
                            : activeConnection?.message?.Direction == "outbound"
                              ? true
                              : callStatus !== "Connected"
                                ? true
                                : false) ||
                          (isShareScreen &&
                            isShareScreen?.CallId == user_id &&
                            isShareScreen?.IsStream === true)
                        }
                      >
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: 33,
                            height: 33,
                            border: "1px solid #1E1F24",
                            backgroundColor: "#1E1F24",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isSharing ? (
                            <StopCircleIcon />
                          ) : (
                            <img
                              src={shareScreen}
                              alt="Screen Icon"
                              style={{ width: 20, height: 20 }}
                            />
                          )}
                        </Box>
                      </IconButton>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "9px",
                            sm: "9px",
                            md: "10px",
                            lg: "12px",
                            xl: "12px",
                          },
                          // "12px"
                        }}
                      >
                        {isSharing ? "Stop" : "Screen Share"}
                      </Typography>
                    </>
                  )}
                </Box>
                {/* <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    justifyContent: "center",
                    color: "#B0B0B0",
                    fontFamily: "Poppins",
                  }}
                >
                  <IconButton
                    color="primary"
                    sx={{
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      },
                      "&.Mui-focusVisible": {
                        boxShadow: "none",
                      },
                    }}
                    disabled={
                      activeConnection?.message?.Direction == "outbound"
                        ? true
                        : callStatus !== "Connected"
                        ? true
                        : false
                    }
                  >
                    <Box
                      sx={{
                        borderRadius: "50%",
                        width: 33,
                        height: 33,
                        border: "1px solid #1E1F24",
                        backgroundColor: "#1E1F24",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={handleAddParticipantOpen}
                    >
                      <img
                        src={AddPeople}
                        alt="Add People"
                        style={{ width: 20, height: 20 }}
                      />
                    </Box>
                  </IconButton>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "9px",
                        sm: "9px",
                        md: "10px",
                        lg: "12px",
                        xl: "12px",
                      },
                    }}
                  >
                    Add People
                  </Typography>
                </Box> */}

                {/* RingCentral records every call automatically at the account
                    level, so the on-demand Record button is hidden for RC calls. */}
                {!isRingCentralCall && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    justifyContent: "center",
                    color: "#B0B0B0",
                    fontFamily: "Poppins",
                  }}
                >
                  {isRecording === false ? (
                    <>
                      <IconButton
                        color="primary"
                        onClick={onToggleRecording}
                        sx={{
                          "&:hover": {
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          },
                          "&.Mui-focusVisible": {
                            boxShadow: "none",
                          },
                        }}
                        disabled={callStatus !== "Connected" ? true : false}
                      >
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: 33,
                            height: 33,
                            border: "1px solid #1E1F24",
                            backgroundColor: "#1E1F24",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={record}
                            alt="record"
                            style={{ width: 20, height: 20 }}
                          />
                        </Box>
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "9px",
                            sm: "9px",
                            md: "10px",
                            lg: "12px",
                            xl: "12px",
                          },
                        }}
                      >
                        Record
                      </Typography>
                    </>
                  ) : (
                    <>
                      <IconButton
                        color="primary"
                        onClick={onToggleRecording}
                        sx={{
                          "&:hover": {
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          },
                          "&.Mui-focusVisible": {
                            boxShadow: "none",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: 33,
                            height: 33,
                            border: "1px solid #1E1F24",
                            backgroundColor: "#1E1F24",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <StopCircleIcon />
                        </Box>
                      </IconButton>
                      <Typography sx={{ fontSize: "12px" }}>Stop</Typography>
                    </>
                  )}
                </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Calling Modal */}
      <Modal
        open={addparticipantModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "auto",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h6"
                color={"#085F99"}
                fontWeight={"bold"}
                fontSize={"18px"}
              >
                Add Participant on Call
              </Typography>
            </Box>
            <IconButton
              sx={{ padding: "0", color: "#085F99" }}
              onClick={() => {
                handleAddParticipantClose();
                setSearchParticipant("");
                setCheckedIds([]);
              }}
            >
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Divider orientation="horizontal" flexItem sx={{ marginY: "10px" }} />

          <Box>
            <TextField
              value={searchParticipant}
              onChange={(e) => {
                setSearchParticipant(e.target.value);
              }}
              variant="outlined"
              fullWidth
              autoComplete="off"
              placeholder="Search Participants..."
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#085F99" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "grey",
                    borderRadius: "20px",
                  },
                  "&:hover fieldset": {
                    borderColor: "#085F99",
                    borderRadius: "20px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#085F99",
                    borderRadius: "20px",
                  },
                },
              }}
            />
            <Box
              sx={{
                padding: "10px 20px",
                height: "40vh",
                overflowY: "auto",
                mt: 2,
              }}
              onScroll={handleScroll}
            >
              {userContactList
                ?.filter(
                  (item) =>
                    callerName != item?.firstName + " " + item?.lastName,
                )
                ?.map((i) => {
                  return (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 2,
                            alignItems: "center",
                          }}
                        >
                          <Avatar
                            sx={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              height: "30px",
                              width: "30px",
                              cursor: "pointer",
                            }}
                            alt="Profile"
                            src={
                              i?.profilePic
                                ? `${s.baseUrl}${i.profilePic}`
                                : undefined
                            }
                            loading="lazy"
                          >
                            {!i?.profilePic &&
                              i?.firstName &&
                              i?.firstName?.charAt(0) &&
                              i?.lastName &&
                              i?.lastName?.charAt(0)}
                          </Avatar>

                          <Typography>
                            {i?.firstName + " " + i?.lastName}
                          </Typography>
                        </Box>
                        <Checkbox
                          icon={<RadioButtonUncheckedIcon />}
                          checkedIcon={<CheckCircleIcon />}
                          // checked={checkedIds.includes(String(i?.userid))}
                          checked={checkedIds.some(
                            (u) => u.userid === i?.userid,
                          )}
                          onChange={() => handleCheckboxChange(i)}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 25,
                              color: "#085F99",
                            },
                          }}
                        />
                      </Box>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ margin: "10px 0px" }}
                      />
                    </>
                  );
                })}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  addParticipantMember(checkedIds);
                  handleAddParticipantClose();
                }}
              >
                Add
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Dialpad Model  */}

      <Modal
        open={dialOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton
              sx={{ padding: "0", color: "#085F99" }}
              onClick={handleCloseDialPad}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
            <Typography
              variant="h6"
              color={"#085F99"}
              fontWeight={"bold"}
              fontSize={"18px"}
            >
              Dial Number
            </Typography>
            <IconButton
              sx={{ padding: "0", color: "#085F99" }}
              onClick={handleCloseDialPad}
            >
              <HighlightOffIcon />
            </IconButton>
          </Box>
          {/* Show Contact Number */}
          {errValidMsg && (
            <Typography
              sx={{
                color: "red",
                fontWeight: "550",
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              {errValidMsg}
            </Typography>
          )}
          <Box padding={"10px"}>
            <TextField
              variant="standard"
              placeholder=""
              value={display}
              onChange={handleInputChange}
              inputRef={inputRef}
              sx={{
                width: "100%",
                borderRadius: "20px",
                "& .MuiOutlinedInput-root": {
                  borderColor: "#BCBCBC",
                },
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#BCBCBC",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#BCBCBC",
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottomColor: "#BCBCBC",
                },

                "& input::placeholder": {
                  color: "gray",
                  opacity: 1,
                },
              }}
            />
          </Box>
          {/* Numbers */}
          <Box sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "10px",
                padding: "0 10px 0 70px",
              }}
            >
              {numbersArray?.map(({ number, letters }, index) => (
                <Box
                  key={index}
                  onClick={() => handleNumberClick(number)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    bgcolor: "#e0f3ff",
                    borderRadius: "50%",
                    width: "70px",
                    height: "70px",
                    cursor: "pointer",
                    boxShadow: 2,
                    "&:hover": {
                      bgcolor: number === number ? "#90c0ff" : "#c0e0ff",
                    },
                    outline: "none",
                    userSelect: "none",
                    "&:focus": { outline: "none" },
                  }}
                >
                  <Typography
                    color={"black"}
                    fontWeight={"bold"}
                    fontSize={"24px"}
                  >
                    {number}
                  </Typography>
                  {letters && (
                    <Typography color={"black"} fontSize={"10px"}>
                      {letters}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                padding: "14px 75px 0 100px",
              }}
            >
              <Box
                width={"100%"}
                paddingLeft={"20px"}
                display={"flex"}
                justifyContent={"center"}
              >
                {/* <IconButton
                  sx={{
                    border: "1px solid #DBDBDB",
                    background: "#4ebc4e",
                    color: "white",
                    borderRadius: "50%",
                    width: "60px",
                    height: "60px",
                    cursor: "pointer",
                    boxShadow: 2,
                    fontSize: "35px",
                    "&:hover": { bgcolor: "#4ebc4e" },
                  }}
                  onClick={() => {
                    if (!display.startsWith("+")) {
                      setErrValidMsg(
                        "Please enter a valid number like +1234567..."
                      );
                      return;
                    } else {
                      handleDial(display.toString(), username, "outbound");
                    }
                  }}
                >
                  <CallIcon fontSize="20px" />
                </IconButton> */}
              </Box>
              <IconButton onClick={handleBackspace}>
                <BackspaceOutlinedIcon sx={{ color: "black" }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default CallScreen;
// Call Modal Style
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "60%", lg: "35%", xl: "35%" },
  bgcolor: "background.paper",
  borderRadius: 2,
  border: "2px solid #FFFFFF",
  p: 2,
};

const calculateCallDuration = (endTime, startTime) => {
  const durationInMilliseconds = dayjs(`1970-01-01T${endTime}`).diff(
    dayjs(`1970-01-01T${startTime}`),
  );
  return Math.floor(durationInMilliseconds / 1000);
};
